export default __webpack_public_path__ + "static/media/EP11_ERYTHREE.22c8cd2d.mp3";